import { render, staticRenderFns } from "./HeaderSteps.vue?vue&type=template&id=c98d6534&scoped=true&"
import script from "./HeaderSteps.vue?vue&type=script&lang=js&"
export * from "./HeaderSteps.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSteps.vue?vue&type=style&index=0&id=c98d6534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98d6534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c98d6534')) {
      api.createRecord('c98d6534', component.options)
    } else {
      api.reload('c98d6534', component.options)
    }
    module.hot.accept("./HeaderSteps.vue?vue&type=template&id=c98d6534&scoped=true&", function () {
      api.rerender('c98d6534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/HeaderSteps.vue"
export default component.exports